import { render } from "./BulkUpdate.vue?vue&type=template&id=4924911e&scoped=true"
import script from "./BulkUpdate.vue?vue&type=script&lang=js"
export * from "./BulkUpdate.vue?vue&type=script&lang=js"

import "./BulkUpdate.vue?vue&type=style&index=0&id=4924911e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4924911e"]])

export default __exports__